(function () {
  if (window.__bb_ic_loaded) return;
  window.__bb_ic_loaded = true;

  var ERP_BASE = "https://erp.bigonbuy.com";
  var SID_KEY = "bb_mkt_sid";

  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getCookie(name) {
    var escaped = name.replace(/[.$?*|{}()\[\]\\/+^]/g, "\\$&");
    var match = document.cookie.match(new RegExp("(?:^|; )" + escaped + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    try {
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; path=/; max-age=" +
        maxAgeSeconds +
        "; SameSite=Lax";
    } catch (_) {}
  }

  function buildFbcFromFbclid() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fbclid = params.get("fbclid");
      if (!fbclid) return null;
      return "fb.1." + Date.now() + "." + fbclid;
    } catch (_) {
      return null;
    }
  }

  function ensureFbcCookie(existingFbc) {
    if (existingFbc) return existingFbc;
    var created = buildFbcFromFbclid();
    if (!created) return null;
    setCookie("_fbc", created, 60 * 60 * 24 * 90); // 90d
    return created;
  }

  function getCached(key) {
    try {
      return localStorage.getItem(key);
    } catch (_) {
      return null;
    }
  }
  function setCached(key, val) {
    try {
      if (val) localStorage.setItem(key, val);
    } catch (_) {}
  }

  function readKeysFresh() {
    var fbpCookie = getCookie("_fbp");
    var fbcCookie = ensureFbcCookie(getCookie("_fbc"));

    if (fbpCookie) setCached("bb_fbp_cache", fbpCookie);
    if (fbcCookie) setCached("bb_fbc_cache", fbcCookie);

    return {
      fbp: fbpCookie || getCached("bb_fbp_cache") || null,
      fbc: fbcCookie || getCached("bb_fbc_cache") || null,
    };
  }

  function getOrCreateSessionId() {
    try {
      var existing = localStorage.getItem(SID_KEY);
      if (existing) return existing;
      var sid = "sid_" + Date.now() + "_" + uuidv4();
      localStorage.setItem(SID_KEY, sid);
      return sid;
    } catch (_) {
      return "sid_" + Date.now() + "_" + uuidv4();
    }
  }

  // Keep event_id stable for a short burst to avoid duplicates from multiple listeners
  function getBurstEventId() {
    try {
      var key = "bb_ic_event_id";
      var tsKey = "bb_ic_event_id_ts";
      var now = Date.now();
      var existing = sessionStorage.getItem(key);
      var existingTs = Number(sessionStorage.getItem(tsKey) || "0");
      if (existing && existingTs && now - existingTs < 10000) return existing;

      var eid = "ic_" + uuidv4();
      sessionStorage.setItem(key, eid);
      sessionStorage.setItem(tsKey, String(now));
      return eid;
    } catch (_) {
      return "ic_" + uuidv4();
    }
  }

  async function fetchCart() {
    try {
      var res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return null;
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  // SAFETY NET: ensure cart attributes contain sid/_fbp/_fbc before checkout
  // This helps Shopify webhook -> note_attributes -> Purchase matching.
  async function syncCartAttributesBeforeCheckout(sessionId, keys) {
    try {
      var attrs = { bb_mkt_sid: sessionId };
      if (keys && keys.fbp) attrs._fbp = keys.fbp;
      if (keys && keys.fbc) attrs._fbc = keys.fbc;

      await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true,
      });
    } catch (_) {}
  }

  function currencyFromCart(cart) {
    // Shopify returns total_price in cents. Currency can be cart.currency or Shopify.currency.active
    var c = cart && (cart.currency || cart.presentment_currency);
    if (c) return String(c).toUpperCase();
    if (window.Shopify && Shopify.currency && Shopify.currency.active)
      return String(Shopify.currency.active).toUpperCase();
    return "INR";
  }

  function buildContents(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      var vid = it.variant_id != null ? String(it.variant_id) : null;
      if (!vid) continue;
      var qty = Number(it.quantity || 1);
      out.push({ id: vid, quantity: qty > 0 ? qty : 1 });
    }
    return out;
  }

  async function fireInitiateCheckout() {
    var cart = await fetchCart();
    if (!cart || !cart.items || !cart.items.length) return;

    var sessionId = getOrCreateSessionId();
    var eventId = getBurstEventId();
    var keys = readKeysFresh();
    var ua = navigator && navigator.userAgent ? String(navigator.userAgent) : null;

    // Safety net: write attributes right before checkout so they appear in order.note_attributes
    // (If you already do this elsewhere, it’s still safe — Shopify just updates same attrs.)
    syncCartAttributesBeforeCheckout(sessionId, keys);

    var contents = buildContents(cart);
    var value = Number(cart.total_price || 0) / 100;
    if (!isFinite(value)) value = 0;

    var currency = currencyFromCart(cart);

    if (window.__bb_mkt_debug) {
      try {
        console.log("[bb] InitiateCheckout", {
          sessionId: sessionId,
          eventId: eventId,
          fbp: keys.fbp,
          fbc: keys.fbc,
          value: value,
          currency: currency,
        });
      } catch (_) {}
    }

    // Pixel (optional)
    if (window.fbq) {
      try {
        window.fbq("track", "InitiateCheckout", {
          content_type: "product",
          contents: contents,
          value: value,
          currency: currency,
          event_id: eventId,
        });
      } catch (_) {}
    }

    // Build minimal payload; do not send nulls inside user_data
    var body = {
      session_id: sessionId,
      contents: contents,
      value: value,
      currency: currency,
      event_id: eventId,
      event_source_url: window.location.href,
    };

    if (keys.fbp) body.fbp = keys.fbp;
    if (keys.fbc) body.fbc = keys.fbc;
    if (ua) body.user_agent = ua;

    // Optional: mirror into user_data (only if non-null)
    var userData = {};
    if (keys.fbp) userData.fbp = keys.fbp;
    if (keys.fbc) userData.fbc = keys.fbc;
    if (Object.keys(userData).length) body.user_data = userData;

    fetch(ERP_BASE + "/api/marketing/initiate-checkout", {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).catch(function () {});
  }

  function matchesCheckoutTarget(el) {
    if (!el || !(el instanceof Element)) return false;

    // most themes
    if (el.closest("button[name='checkout']")) return true;
    if (el.closest("button[type='submit'][name='checkout']")) return true;

    // common cart buttons / attributes
    if (el.closest("[data-checkout]")) return true;
    if (el.closest("[data-cart-checkout]")) return true;

    // common classes (theme dependent)
    if (el.closest(".checkout-button")) return true;
    if (el.closest(".cart__checkout-button")) return true;

    // anchor checkout
    var a = el.closest("a[href]");
    if (a) {
      var href = (a.getAttribute("href") || "").toLowerCase();
      if (href.indexOf("/checkout") !== -1) return true;
    }

    return false;
  }

  function attachCheckoutListeners() {
    var CHECKOUT_LOCK_MS = 2000;
    var checkoutLockedUntil = 0;

    document.addEventListener(
      "click",
      function (e) {
        var t = e.target;
        if (!matchesCheckoutTarget(t)) return;

        var now = Date.now();
        if (now < checkoutLockedUntil) return;
        checkoutLockedUntil = now + CHECKOUT_LOCK_MS;

        fireInitiateCheckout();
      },
      true
    );

    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        var action = (form.getAttribute("action") || "").toLowerCase();
        // Shopify checkout POSTs often go to /checkout or /cart
        if (action.indexOf("/checkout") === -1 && action.indexOf("/cart") === -1) return;

        var now = Date.now();
        if (now < checkoutLockedUntil) return;
        checkoutLockedUntil = now + CHECKOUT_LOCK_MS;

        fireInitiateCheckout();
      },
      true
    );
  }

  // Ensure _fbc exists when fbclid present
  ensureFbcCookie(getCookie("_fbc"));

  attachCheckoutListeners();
})();
